import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiKeyService } from '../services/apiKeyService';
import { UpdateApiKeyDto } from '../types/apiKey';

export const useApiKeys = () => {
  const queryClient = useQueryClient();

  const { data: apiKeys = [], isLoading, error } = useQuery({
    queryKey: ['apiKeys'],
    queryFn: apiKeyService.getApiKeys,
  });

  const createApiKey = useMutation({
    mutationFn: apiKeyService.createApiKey,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['apiKeys'] });
    },
  });

  const updateApiKey = useMutation({
    mutationFn: ({ key, data }: { key: string; data: UpdateApiKeyDto }) =>
      apiKeyService.updateApiKey(key, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['apiKeys'] });
    },
  });

  const deleteApiKey = useMutation({
    mutationFn: apiKeyService.deleteApiKey,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['apiKeys'] });
    },
  });

  return {
    apiKeys,
    isLoading,
    error,
    createApiKey,
    updateApiKey,
    deleteApiKey,
  };
}; 